import { render, staticRenderFns } from "./MoreInfosModal.vue?vue&type=template&id=7fb5aa50&"
import script from "./MoreInfosModal.vue?vue&type=script&lang=ts&"
export * from "./MoreInfosModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports